export const CANVAS_WIDTH = 1200
export const SLIDE_PREVIEW_WIDTH_CONTENT_SELECTOR = 300
